import { useCallback, useContext, useState } from 'react';
import { useLocation } from 'react-router';
import { assertIsDefined } from '@/helpers/assertions';
import { PermissionDeniedContext } from '@/providers/PermissionDeniedProvider/PermissionDeniedContextProvider';

export const usePermissionDeniedManager = () => {
  const { pathname } = useLocation();
  const [deniedPathname, setDeniedPathname] = useState<string | null>(null);

  const markPermissionDenied = useCallback(() => {
    setDeniedPathname(window.location.pathname);
  }, []);

  return { isPermissionDenied: deniedPathname === pathname, markPermissionDenied };
};

export const usePermissionDenied = () => {
  const { isPermissionDenied, markPermissionDenied } = useContext(PermissionDeniedContext);

  assertIsDefined(
    isPermissionDenied,
    '"IPermissionDeniedContext.isPermissionDenied has to be defined!"',
  );
  assertIsDefined(
    markPermissionDenied,
    '"IPermissionDeniedContext.markPermissionDenied has to be defined!"',
  );

  return { isPermissionDenied, markPermissionDenied };
};
